import {Component} from 'react';
import reformatDateToDisplay from '../../../objects/CommonUse/reformatDateToDisplay_function';
import { doubleToStringMonthly } from '../../../objects/CommonUse/double_functions';

class SavingsChangeConfirmCDList extends Component {
    constructor(props) {
        super(props);
        this.state = {
        };
       
    }

  
    render() {
        let currentAutoRollover = "Yes";
        if (this.props.tableInfo.autoRollover === false){
            currentAutoRollover = "No";
        }
        let newAutoRollover = "Yes";
        if (this.props.tableInfo.newAutoRollover === false){
            newAutoRollover = "No";
        }
    return <>
        <tr className={this.rowClass}>
            <td className="text-center p-2">{reformatDateToDisplay(this.props.tableInfo.date)}</td>
            <td className="text-center p-2">{doubleToStringMonthly(this.props.tableInfo.amount)}</td>
            <td className="text-center p-2">{currentAutoRollover}</td>
            <td className="text-center p-2">{newAutoRollover}</td>
        </tr>

    </>
    }
}

export default SavingsChangeConfirmCDList;